export function transformSeoNavbar(response) {
    return response;
}
